export default class Helpers {

  static sortByLowestPrice(a, b) {
    return b.isDisplayed - a.isDisplayed ||
      a.price - b.price ||
      a.originalPosition - b.originalPosition;
  }

  static sortByHighestPrice(b, a) {
    return b.isDisplayed - a.isDisplayed ||
      a.price - b.price ||
      a.originalPosition - b.originalPosition;
  }

  static sortByDisplayed(a, b) {
    return b.isDisplayed - a.isDisplayed || a.originalPosition - b.originalPosition;
  }

}
